export var SIZE;
(function (SIZE) {
    SIZE["SML"] = "sml";
    SIZE["MED"] = "med";
    SIZE["LRG"] = "lrg";
})(SIZE || (SIZE = {}));
//# sourceMappingURL=constants.js.map